import { render, staticRenderFns } from "./ListAccessories.vue?vue&type=template&id=4f423c88&scoped=true"
import script from "./ListAccessories.vue?vue&type=script&lang=js"
export * from "./ListAccessories.vue?vue&type=script&lang=js"
import style0 from "./ListAccessories.vue?vue&type=style&index=0&id=4f423c88&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f423c88",
  null
  
)

export default component.exports